import { useState, useEffect } from 'react';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const useRegisterStudentCourses = (id) => {
  const [learningItems, setLearningItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchLearningItems = async () => {
    if (!id) return;
    try {
      setLoading(true);
      const response = await fetch(`${BASE_URL}/student/register-courses/${id}/`,{
          headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
      });
      if (!response.ok) throw new Error('Failed to fetch learning items');
      const data = await response.json();
      setLearningItems(data);
    } catch (error) {
      console.error('Error fetching learning items:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLearningItems();
  }, [id]);

  return { learningItems, loading };
};

export default useRegisterStudentCourses;
